<template>
  <div>
    <div class="page-title">New School</div>
    <Form btnText="Add School" v-model="form" :submit="create" />
  </div>
</template>

<script>
import Form from "./_form.school.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setSchool();
  },
  methods: {
    async setSchool() {
      const { data } = await this.$api.School.new();
      this.form = data;
    },
    async create() {
      await this.$api.School.create(this.form);
      this.$router.push("/schools");
    },
  },
};
</script>

<style></style>
